import { render, staticRenderFns } from "./UiTooltip.vue?vue&type=template&id=e90fafd8&scoped=true&"
import script from "./UiTooltip.vue?vue&type=script&lang=js&"
export * from "./UiTooltip.vue?vue&type=script&lang=js&"
import style0 from "./UiTooltip.vue?vue&type=style&index=0&id=e90fafd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90fafd8",
  null
  
)

export default component.exports